const createdFormatters = new Map<string, Intl.NumberFormat>();

export const formatCurrency = (
  amount: number,
  currency: string = 'EUR'
) => {
  if (!createdFormatters.has(currency)) {
    createdFormatters.set(currency, new Intl.NumberFormat('fr-FR', { style: 'currency', currency }));
  }
  return createdFormatters.get(currency)!.format(amount);
};